import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ForecastItemClient, FormulationTypesClient, ForecastItemModel, QuantityUnitOfMeasureModel,
         ForecastTypeClient, UserClient, ForecastingSeasonClient, ForecastingSeasonModel,
         ForecastStateClient, QuantityUomClient, ConcentrationUomClient, UserModel} from '../forecast-api-client.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ModifyForecastResolver implements Resolve<Observable<any>> {
    constructor(
        private forecastItemClient: ForecastItemClient,
        private uomService: QuantityUomClient,
        private cuonService: ConcentrationUomClient,
        private forecastTypeClient: ForecastTypeClient,
        private formulationTypeClient: FormulationTypesClient,
        private userClient: UserClient,
        private forecastingSeasonClient: ForecastingSeasonClient,
        private forecastStateClient: ForecastStateClient ){}
    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) : Observable<any> {
        let id = route.params['id'];
        return forkJoin(
            this.uomService.get3(false),
            this.cuonService.get(false),
            this.forecastStateClient.getForecastStates(),
            this.forecastTypeClient.getForecastTypes(),
            this.formulationTypeClient.get2(true),
            this.userClient.getUsersInRoles(['Biology Leader']),
            this.forecastingSeasonClient.getForecastingSeasons(),
            this.forecastItemClient.getForecastItem(id)
        )
        .pipe(
            map(([uoms, cuoms, forecastStates, forecastTypes,
                  formulationTypes, reviewers, forecastingSeasons,
                  editForecastItem]) => {
                uoms = uoms.filter(x => x.id === editForecastItem.quantityUnitOfMeasureId ||
                    x.isEnabled || editForecastItem.forecastItemDestination.some(y => y.packSizeUomId === x.id));
                cuoms = cuoms.filter(x => x.isEnabled ||
                editForecastItem.forecastItemActiveIngredient.some(a => x.id === a.concentrationUomId));
                formulationTypes.forEach(x => { x.formulationTypeLabelDesc = x.formulationTypeCode + '-' + x.description; });
                var fsm = new ForecastingSeasonModel(); fsm.id = null; fsm.name = null;
                forecastingSeasons.push(fsm);
                return {uoms, cuoms, forecastStates, forecastTypes, formulationTypes,
                    reviewers, forecastingSeasons, editForecastItem};
            })
        )
    }
}
